import tassuApuLogo from "./logo_paw.svg";

const globalTiles = {
  tassuApuLogo,
};

export default globalTiles;
